'use client'
import './LoadingImg.css'
import { twMerge } from 'tailwind-merge'
type LoadingImgProps = {
  className?: string
  color?: string
}

export default function LoadingImg({ className, color }: LoadingImgProps) {
  return (
    <div
      className={twMerge('lds-spinner', className)}
      style={{ '--spinner-color': color || '#fff' } as React.CSSProperties}
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}
